import { createAction, props } from '@ngrx/store';

export const updatePropertiesIsLoadingFromPropertySavingData = createAction(
  '[PropertySavingData] Update Properties Is Loading',
  props<{ isLoading: boolean }>()
);